import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  toggle() {
    if (this.hasCheckboxTarget) {
      this.checkboxTarget.checked = !this.checkboxTarget.checked
    }
  }

  close() {
    if (this.hasCheckboxTarget) {
      this.checkboxTarget.checked = false
    }
  }
}
